import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';
import { WebcamImage } from 'ngx-webcam';
import { Observable, of } from 'rxjs';
import { debounceTime, map, startWith, switchMap, tap } from 'rxjs/operators';
import { PeopleDto } from '../models/people.model';
import { SurveyQuestion } from '../models/survey-question.model';
import { ImageService } from '../services/image/image.service';
import { SurveyService } from '../services/survey.service';


export interface CovidTestData {
  testDate: Date;
  testManufacturer: string;
  testType: string;
  testResult: string;
  testObserver: string;
  files: any[];
  resultAnswerText: string;
  testLocationId: string;
  testLotNumber: string;
  purpose: string;
  expirationDate: Date;
  amendExpirationDate: Date;
  testRedCntrlLinePresent: string;
}


//export const MY_FORMATS = {
//  parse: {
//    dateInput: 'MM/YYYY',
//  },
//  display: {
//    dateInput: 'MM/YYYY',
//    monthYearLabel: 'MMM YYYY',
//    dateA11yLabel: 'LL',
//    monthYearA11yLabel: 'MMMM YYYY',
//  },
//};

@Component({
  selector: 'app-covid-test',
  templateUrl: './covid-test.component.html',
  styleUrls: ['./covid-test.component.css'],
  inputs: ['corpId'],
  //providers: [
  //    {
  //      provide: DateAdapter,
  //      useClass: MomentDateAdapter,
  //      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
  //    },

  //    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  //],
})
export class CovidTestComponent implements OnInit {
  public data: CovidTestData;
  filteredPeople: Observable<PeopleDto[]>;
  uploadUrl: string;
  currentQuestion: SurveyQuestion;
  color: string = "black";
  weight: string = "normal";
  public testResultOptions = [];
  public testTypeOptions = [];
  public testLocationOptions = [];
  webCamImages: WebcamImage[] = [];
  disableTestResult: boolean = true;
  testRslt: string;
  redLineValue: string;
  corpId: string;
  expiration = new UntypedFormControl(moment());
  amendExpirationDate: string = "";
  displayInvalidMsg: boolean = false;

  files = [];

  // public ngToggleModel: any = {
  //   onColor: 'success',
  //   offColor: 'danger',
  //   onText: 'Pass',
  //   offText: 'Fail',
  //   disabled: false,
  //   size: 'lg',
  //   value: null
  // };

  @ViewChild('covidForm', { static: false }) covidForm;
  @ViewChild('camera', { static: false }) camera;
  @Output() covidTestEvent = new EventEmitter<CovidTestData>();
  @Input() purpose: string;
  myPeoplePickerFormGroup: UntypedFormGroup;

  maxDate = new Date();
  groups = [];
  markets = [];
  selectedGroup: any;

  constructor(private surveyService: SurveyService,
    private imageService: ImageService,
  ) { }

  async ngOnInit() {
    this.data = {} as CovidTestData;

    let covidTestOptions = await this.surveyService.getCovidTestOptions().toPromise();
    this.testResultOptions = covidTestOptions.filter(o => o.listName == 'CovidTestResultOptions');
    this.testTypeOptions = covidTestOptions.filter(o => o.listName == 'CovidTestTypeOptions');

    //Default Form data fields
    this.data.testType = this.testTypeOptions[0].optionId;
    this.data.testDate = new Date();
    this.data.testRedCntrlLinePresent = null;
    this.data.testResult = "Invalid";

    this.myPeoplePickerFormGroup = new UntypedFormGroup({
      peoplePickerControl: new UntypedFormControl('', Validators.required)
    });
    this.filteredPeople = this.myPeoplePickerFormGroup.get('peoplePickerControl').valueChanges.pipe(
      startWith(""),
      debounceTime(400),
      switchMap((value) => this.surveyService.getPeople(value))
    ).pipe(map(ppl => ppl.filter(item => item.corpId !== this.corpId)));
    this.data.testLotNumber = '';
    this.groups = await this.surveyService.getGroups().toPromise();
  }
  /*this.itemObservable.pipe (
    map(items => 
     items.filter(item => item.name.toLowerCase().indexOf(query) > -1)) )
     */
  ngDoCheck() {
    if (this.myPeoplePickerFormGroup === undefined || this.myPeoplePickerFormGroup.status == "INVALID") {
      this.data.testObserver = '';
      return;
    }
    if (!this.data.testRedCntrlLinePresent) return;
    if (this.covidForm.status == "INVALID") return;
    if (this.data.testObserver === undefined || this.data.testObserver === '') return;
    if (this.files.length == 0) return;
    //if(this.ngToggleModel.value == null) return;
    if (this.data.testResult === undefined) return;
    if (this.data.testLocationId === undefined) return;

    if (this.data.testLotNumber === '') return;

    this.data.files = this.files;
    console.log('docheck files',this.data.files);
    // this.data.testResult = this.ngToggleModel.value == true ? this.ngToggleModel.onText : this.ngToggleModel.offText;
    // //update answer text
    // if(moment(this.data.testDate).add(8, 'days') > moment() && this.ngToggleModel.value ){
    //   this.data.resultAnswerText = this.ngToggleModel.onText;
    // }
    // else if (this.ngToggleModel.value == false){
    //   this.data.resultAnswerText = this.ngToggleModel.offText;
    // }
    // else{
    //   this.data.resultAnswerText = 'NotCompliant';
    // }

    if (this.data.testResult !== '') {
      if (this.purpose == 'Asymptomatic') {
        if (moment(this.data.testDate).add(4, 'days') > moment() && this.data.testResult == 'Negative') {
          this.data.resultAnswerText = this.data.testResult;
        }
        else if (this.data.testResult == 'Positive') {
          this.data.resultAnswerText = this.data.testResult;
        }
        else {
          this.data.resultAnswerText = 'Invalid';
        }
      }
      else {
        if (moment(this.data.testDate).add(8, 'days') > moment() && this.data.testResult == 'Negative') {
          this.data.resultAnswerText = this.data.testResult;
        }
        else if (this.data.testResult == 'Positive') {
          this.data.resultAnswerText = this.data.testResult;
        }
        else {
          this.data.resultAnswerText = 'NotCompliant';
        }
      }
    }
    else {
      this.data.resultAnswerText = '';
    }

    this.data.purpose = this.purpose;

    console.log('do check', this.data);
    this.covidTestEvent.emit({ ...this.data });
  }

  handleImage(pictures) {
    //this.webCamImages = pictures;
    console.log('CovidTestComponent.handleImage', pictures);
    this.files = [];
    pictures.forEach(p => {
      this.imageService.resizeImage(p.imageAsDataUrl, 1000, 1000).then(data => {
        this.files.push(data);
      });
    });
  }

  handleCovidExpDate(covidTestExpDate) {
    console.log(covidTestExpDate);
    //this.onDateChg('change', covidTestExpDate);
    this.data.expirationDate = covidTestExpDate;
    this.getAmendedExpDate(this.data.testType, covidTestExpDate);
  }


  onSelectFile(event) { // called each time file input changes
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]); // read file as data url      
      reader.onload = (event) => { // called once readAsDataURL is completed
        if (reader.result.toString().includes("image") || reader.result.toString().includes("application/pdf")) {
          this.uploadUrl = reader.result.toString();
          this.color = "black";
          this.weight = "normal";
          // only resize images
          if (reader.result.toString().includes("image")) {
            this.imageService.resizeImage(reader.result.toString(), 1000, 1000).then(data => {
              this.files.push(data);
            });
          }
          else {
            this.files.push(reader.result);
          }
        }
        else {
          this.color = "red";
          this.weight = "bold";
          this.uploadUrl = "";
        }
      }
    }
  }

  onSelectTestBrand(event) {
    let testBrand = event.value;
    this.getAmendedExpDate(testBrand, this.data.expirationDate);
  }

  onSelectRedCntrlLinePresent(selValue) {
    this.redLineValue = selValue;

    const eom = this.getLastDayOfMonth(moment(this.data.amendExpirationDate).month() + 1, moment(this.data.amendExpirationDate).year());

    if (selValue == "Yes" && moment(eom) >= moment()) {
      this.disableTestResult = false;
      this.data.testResult = "";
      this.displayInvalidMsg = false;
    }
    else {
      this.disableTestResult = true;
      this.data.testResult = "Invalid";
      this.displayInvalidMsg = true;
    }
  }

  onSelectResultChg(rsltValue) {
    this.testRslt = rsltValue;
  }

  onSelectPeople(event) {
    this.data.testObserver = event.option.value.split("-")[0];
  }


  public getLastDayOfMonth(month: number, year: number) {
    const lastDayOfMonth = new Date(year, month + 1, 0);
    const day1 = lastDayOfMonth.getDate();
    return new Date(year, month, day1);
  }

  async getAmendedExpDate(testBrand: string, expirationDate: Date) {
    if (expirationDate != null) {
      console.log('Get Amended Expiration Date: ', testBrand, expirationDate);
      this.data.amendExpirationDate = await this.surveyService.getCovidTestAmendedExpDate(testBrand, expirationDate.toDateString()).toPromise();
      console.log('AmendedExpDate = ', this.data.amendExpirationDate);

      const theMonth = moment(this.data.amendExpirationDate).month() + 1;
      const theYear = moment(this.data.amendExpirationDate).year();
      const amendDateMo = theMonth.toString().length == 1 ? "0" + theMonth.toString() : theMonth.toString();
      const amendDateYr = theYear.toString();
      this.amendExpirationDate = amendDateMo + "/" + amendDateYr;


      const eom = this.getLastDayOfMonth(theMonth, theYear);

      if (moment(eom) >= moment() && this.redLineValue === "Yes") {
        this.disableTestResult = false;
        this.data.testResult = this.testRslt;
        this.displayInvalidMsg = false;
      }
      else {
        this.disableTestResult = true;
        this.data.testResult = "Invalid";
        this.displayInvalidMsg = true;
      }
    }
  }

  async onSelectedLocationGroupChanged(groupId) {
    this.selectedGroup = this.groups.find(g => g.optionId == groupId).optionValue;
    this.markets = [];
    this.markets = await this.surveyService.getMarkets(groupId).toPromise();
    this.testLocationOptions = [];
    this.data.testLocationId = undefined;
  }

  async onSelectedMarketChanged(marketCode) {
    this.testLocationOptions = await this.surveyService.getLocations(this.selectedGroup, marketCode).toPromise();
  }

}
